import { injectable } from 'inversify';
import { CallbackManager, CallbackSubscription } from '../Utilities/CallbackManager';

@injectable()
export class CancellationController {
  private readonly _cancelEvents: Map<string, CallbackManager<() => Promise<void>>>;

  public constructor() {
    this._cancelEvents = new Map();
  }

  public async cancelAction(descriptor: string): Promise<void> {
    await this._cancelEvents.get(descriptor)?.invokeAsync();
    this._cancelEvents.delete(descriptor);
  }

  public addCancelEvent(descriptor: string, callback: () => Promise<void>): CallbackSubscription {
    if (!this._cancelEvents.has(descriptor)) {
      this._cancelEvents.set(descriptor, new CallbackManager());
    }

    const manager = this._cancelEvents.get(descriptor);
    if (manager === undefined) {
      throw new Error(`No manager for event: ${descriptor}`);
    }

    return manager.subscribe(callback);
  }

  public removeCancelEvent(descritptor: string): void {
    this._cancelEvents.delete(descritptor);
  }

  public isCancelable(descriptor: string): boolean {
    return this._cancelEvents.has(descriptor);
  }
}
